<script setup>
import SCardWithToolbar from '@/components/global/s-card-with-toolbar.vue'
import FormPrepaVersement from '@/components/fiche-aim/fiche-aim/versements/form-prepa-versement.vue'
import AidePrepaVersementsDialog from '@/components/fiche-aim/fiche-aim/versements/aide-prepa-versements-dialog.vue'
import VersementsDuMoisList from '@/components/fiche-aim/fiche-aim/versements/versementList/liste-versements-du-mois.vue'
</script>

<template>
  <s-card-with-toolbar :elevation="2">
    <template #titre>Versements</template>
    <template #actions>
      <aide-prepa-versements-dialog />
    </template>
    <template #default>
      <form-prepa-versement :mois="mois" :annee="annee" />
      <v-navigation-drawer v-model="drawer" absolute bottom mobile-breakpoint="2000">
        <versements-du-mois-list :usager-id="usagerId" :annee="annee" :mois="mois" />
      </v-navigation-drawer>
    </template>
    <template #bottom>
      <v-row justify="space-between" no-gutters class="pa-2">
        <v-badge overlap color="secondary" :value="newVersementCount > 0" :content="newVersementCount">
          <v-btn class="pl-0" color="primary" @click.stop="handleDrawerOpen">
            <v-progress-circular class="mx-2" size="24" indeterminate v-if="versementLoading" />
            <v-icon class="mx-2" v-else> mdi-arrow-expand-up </v-icon>
            Versements du mois
          </v-btn>
        </v-badge>
        <v-btn class="pl-0" color="primary" @click="handlePreparerVersement" :disabled="!isValid">
          <v-icon class="mx-2"> mdi-check </v-icon>
          Declarer les versements
        </v-btn>
      </v-row>
    </template>
  </s-card-with-toolbar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'versements-aim',
  props: {
    annee: {
      type: Number,
      required: true,
    },
    mois: {
      type: Number,
      required: true,
    },
    usagerId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      versementLoading: false,
      newVersementCount: 0,
      drawer: false,
    }
  },
  computed: {
    ...mapGetters({
      etablissement: 'application/getSelectedEtablissement',
      dates: 'preparationVersement_IHM_helper/getDatesVersements',
      lignes: 'preparationVersement_IHM_helper/getLignesVersements',
      moyenDePaiementId: 'preparationVersement_IHM_helper/getMoyenDePaiementId',
      isValid: 'preparationVersement_IHM_helper/isValid',
    }),
    preparerVersementMultidateCommand() {
      return {
        usagerId: this.usagerId,
        etablissementId: this.etablissement.etablissementId,
        datesDeVersement: this.dates,
        lignesVersements: this.lignes,
        moyenDePaiementId: this.moyenDePaiementId,
      }
    },
  },
  methods: {
    ...mapActions({
      preparerVersementMultidate: 'versement/preparerVersementMultidate',
      razAll: 'preparationVersement_IHM_helper/razAll',
    }),
    handlePreparerVersement() {
      this.versementLoading = true
      this.preparerVersementMultidate(this.preparerVersementMultidateCommand).then((value) => {
        this.versementLoading = false
        this.newVersementCount += value.length
        this.razAll()
      })
    },
    handleDrawerOpen() {
      this.drawer = true
      this.newVersementCount = 0
    },
  },
}
</script>

<style>
.fixed-height {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100%;
  overflow: hidden;
}
</style>
